'use client'

import { createComponent } from '@lit/react'
import { type IPktProgressbar as IPktElProgressbar, PktProgressbar as PktElProgressbar } from '@oslokommune/punkt-elements'
// eslint-disable-next-line no-restricted-syntax -- React is required for createComponent
import React, { ForwardedRef, forwardRef, type ReactElement } from 'react'

import type { PktElConstructor, PktElType } from '@/interfaces/IPktElements'

type ExtendedProgressbar = IPktElProgressbar & PktElType

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IPktProgressbar extends ExtendedProgressbar {}

const LitComponent = createComponent({
  tagName: 'pkt-progressbar',
  elementClass: PktElProgressbar as PktElConstructor<HTMLElement>,
  react: React,
  displayName: 'PktProgressbar',
  events: {},
})

export const PktProgressbar = forwardRef(
  ({ children, ...props }: IPktProgressbar, ref: ForwardedRef<HTMLElement>): ReactElement => {
    return (
      <LitComponent ref={ref} {...props}>
        <div className="pkt-contents">{children}</div>
      </LitComponent>
    )
  },
)

PktProgressbar.displayName = 'PktProgressbar'
